/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Segment } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeTool } from "../slices/footer/footerSlice";
import submitGradeproId from "../functions/submitGradeproIdAPI";
import AlertModal from "./AlertModal";

// eslint-disable-next-line no-empty-pattern
const GradeProConverterPage = ({ }) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR GRADEpro-to-FEvIR Converter"));
        dispatch(changeTool("Computable Publishing®: GRADEpro-to-FEvIR Converter"));
    }, []);

    const [gradeproEntryState, setGradeproEntryState] = useState({
        "title": "",
        "description": "This project was created by the Computable Publishing®: GRADEpro-to-FEvIR Converter.",
        "status": "active", "gradepro": "", "gradeproFileUploaded": "", "gradeProId": ""
    });
    //const [submittingResources, setSubmittingResources] = useState(false);
    const [alertModalState, setAlertModalState] = useState({
        open: false, alertHistory: [], header: "", content: ""
    });

    const submitGradeProId = async (gradeProId, redirect) => {

        if (gradeProId) {
            dispatch(globalLoadingOn());
            //setSubmittingResources(true);
            try {
                if (redirect === undefined) {
                    redirect = true;
                }
                let response = await submitGradeproId(gradeProId, apiToken);
                if (response?.success) {
                    if (redirect) {
                        if (response.jobAlreadyRunning && response.message) {
                            setAlertModalState(prevState => {
                                return {
                                    ...prevState,
                                    "open": true,
                                    "header": "Job Currently In Process",
                                    "content": response.message
                                };
                            });
                        } else if (response.numberOfResourcesCreated) {
                            if (response.largeCollection) {
                                setAlertModalState(prevState => {
                                    return {
                                        ...prevState,
                                        "open": true,
                                        "header": "Processing",
                                        "content": "The GRADEpro record was converted to " + response.numberOfResourcesCreated + " FHIR Resources. Because the number of Resources created is so large, it may take a few minutes before the referenced Resources are loaded to the FEvIR Platform."
                                    };
                                });
                            } else {
                                setAlertModalState(prevState => {
                                    return {
                                        ...prevState,
                                        "open": true,
                                        "header": "Complete",
                                        "content": "The GRADEpro record was converted to " + response.numberOfResourcesCreated + " FHIR Resources."
                                    };
                                });
                            }
                        } else if (response.message) {
                            setAlertModalState(prevState => {
                                return {
                                    ...prevState,
                                    "open": true,
                                    "header": "",
                                    "content": response.message
                                };
                            });
                        }
                        if (response.compositionfoi) {
                            //dispatch(changeFoiFocus(response.compositionfoi));
                            navigate(`/resources/Composition/${response.compositionfoi}`);
                        }
                    }
                } else if (response?.errormessage) {
                    setAlertModalState(prevState => {
                        return {
                            ...prevState,
                            "open": true,
                            "header": "Error",
                            "content": response.errormessage
                        };
                    });
                } else {
                    setAlertModalState(prevState => {
                        return {
                            ...prevState,
                            "open": true,
                            "header": "Error",
                            "content": "We were unable to convert this citation. Perhaps this GRADEpro ID: " + gradeProId + " doesn't exist or there are issues in its structure."
                        };
                    });
                }

            } catch (e) {
                console.log("ERROR with submitGradeproId");
                console.log(e);
            }
            //setSubmittingResources(false);
            dispatch(globalLoadingOff());
        } else {
            setAlertModalState(prevState => {
                return {
                    ...prevState,
                    "open": true,
                    "header": "Error",
                    "content": "Please enter a GRADEpro ID."
                };
            });
        }
    }

    const handleKeyUp = (event) => {
        if (event.key === 'Enter' && !alertModalState.open) {
            submitGradeProId(gradeproEntryState.gradeProId, true);
        }
    }

    return (
        <div>
            {/*submittingResources &&
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Submitting</Loader>
                </Dimmer>
            */}
            <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <br />
                {apiToken ?
                    <>
                        <TextField style={{ width: "560px" }} className="inputField" type='text'
                            label={'GRADEpro ID'} size="small" variant='outlined'
                            value={gradeproEntryState.gradeProId || ''}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => {
                                setGradeproEntryState(prevState => {
                                    return { ...prevState, inputChanged: true, gradeProId: e.target.value };
                                });
                            }}
                        />
                        <br />
                        <br />
                        <Button className="formButton positive"
                            content="Convert GRADEpro to FEvIR" compact
                            onClick={() => {
                                submitGradeProId(gradeproEntryState.gradeProId, true);
                            }} />
                    </>
                    :
                    <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
                }
            </Segment>
        </div>
    );
};

export default GradeProConverterPage;